export const dataHooks = {
  overlineContainer: 'overline-container',
  overline: 'overline',
  titleContainer: 'title-container',
  title: 'title',
  subtitleContainer: 'subtitle-container',
  subtitle: 'subtitle',
  contentContainer: 'content-container',
  content: 'content',
  actions: 'actions',
} as const;

export const size = {
  medium: 'medium',
  large: 'large',
} as const;
